export const dataMonths = [{
  word: 'Janvyé',
  partOfSpeech: 'N',
  definition: ['January'],
  egSentenceKw: 'Sé manmay-la pa té vlé viwé lékòl an Janvyé.',
  egSentenceEn: 'The children didn\'t want to return to school in January.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. janvier',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Févwiyé',
  partOfSpeech: 'N',
  definition: ['February'],
  egSentenceKw: 'Sé an mwa Févwiyé nou ka sélébwé andépandans nou.',
  egSentenceEn: 'It is in the month of February we celebrate our independence.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. février]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Mas',
  partOfSpeech: 'N',
  definition: ['March'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mars]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Avwi',
  partOfSpeech: 'N',
  definition: ['April'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. avril]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Mé',
  partOfSpeech: 'N',
  definition: ['May'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mai]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Jen',
  partOfSpeech: 'N',
  definition: ['June'],
  egSentenceKw: 'Sézon mové tan ka koumansé an mwa Jen.',
  egSentenceEn: 'The hurricane season begins in June.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juin]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Jwiyèt',
  partOfSpeech: 'N',
  definition: ['July'],
  egSentenceKw: 'Péyi Sent Lisi ka sélébwé kannaval an Jwiyèt atjwèlman.',
  egSentenceEn: 'St. Lucia celebrates carnival in July now.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juillet]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Awou',
  partOfSpeech: 'N',
  definition: ['August'],
  egSentenceKw: 'Mwa Awou sé mwa manmay lékòl asou vakans.',
  egSentenceEn: 'The month of August is the month when the school children are on vacation.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. août]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Sèptanm',
  partOfSpeech: 'N',
  definition: ['September'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. septembre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Òktòb',
  partOfSpeech: 'N',
  definition: ['October'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. octobre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Novanm',
  partOfSpeech: 'N',
  definition: ['November'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. novembre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Désanm',
  partOfSpeech: 'N',
  definition: ['December'],
  egSentenceKw: 'Sé an mwa Désanm Nwèl ka tonbé.',
  egSentenceEn: 'It is in the month of December Christmas falls.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. decembre]',
  dialect: '🇱🇨',
  variant: [null],
},
];
